import {MolecularGraph} from "../../graph/MolecularGraph"
import {extractorUtil} from "../../util/extractorUtil";
import {Feature} from "../../feature";
import {rGroupFinder} from "../../util/rGroupFinder";

export const rxrExtractor = {
    extract: (e: string, feature: string, graph: MolecularGraph) => {
        const Xs = extractorUtil.getFunctionalGroupRootsWithElement(e, graph);

        const features: Feature[] = [];
        // Ethers only have 2 bonds to single carbons
        Xs.forEach(x => {
            const bonds = extractorUtil.getSingleBondsToC(x, graph);
            if(bonds.length === 2) {
                const a = [x]
                const r = rGroupFinder.get(graph, a);
                features.push({name: feature, atoms: a, connections: r})
            }
        })

        return features;
    }
}
